import * as Primus from "../../../assets/js/primus";

class IoService {
    public static $inject = [
        "$log",
        "authService",
        "configService"
    ];

    private $log;
    private authService;

    private isConnectionInitialized = false;
    private primus;

    constructor(
        $log,
        authService,
        configService
    ) {
        this.$log = $log;
        this.authService = authService;
        this.primus = Primus.connect(configService.primus.endpoint, configService.primus.options);

        this.primus.isOpen = () => {
            return this.primus.readyState === (<any>Primus).OPEN;
        };

        this.primus.manualOpen = () => {
            if (this.isConnectionInitialized) {
                this.primus.end().open();
            } else {
                this.isConnectionInitialized = true;
                this.primus.open();
            }
        };

        this.primus.on("outgoing::url", url => {
            url.query = "token=" + (this.authService.getAccessToken() || "");
        });

        this.primus.on("error", this.$log.error);

        this.primus.on("reconnect", () => {
            this.$log.info("IO - Initialize reconnection.");
        });

        this.primus.on("reconnect scheduled", options => {
            this.$log.info(`IO - Reconnecting in ${ options.scheduled } ms`);
            this.$log.info(`IO - This is attempt ${ options.attempt } out of ${ options.retries }`);
        });

        this.primus.on("reconnected", options => {
            this.$log.info(`IO - It took ${ options.duration } ms to reconnect`);
        });

        this.primus.on("reconnect timeout", err => {
            this.$log.warn(`IO - Timeout expired: ${ err.message }`);
        });

        this.primus.on("reconnect failed", err => {
            this.$log.warn(`IO - The reconnection failed: ${ err.message }`);
        });

        this.primus.on("open", () => {
            this.$log.info("IO - Connected.");
        });

        this.primus.on("close", () => {
            this.$log.info("IO - Disconnected (close)");
        });

        this.primus.on("end", () => {
            this.$log.info("IO - Disconnected (end)");
        });

        return this.primus;
    }
}

angular
    .module("thor.core.io", [])
    .service("io", IoService);
